<template>
  <section>
    <!-- top-menu -->
    <top-menu/>
    <!-- Loading from page -->
    <full-loading v-if="loadingGeneral"/>
    <!-- detail-days-user -->
    <section v-else>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-md-12 content-block">
            <div class="content-header">
              <span class="header-title">
                <ion-icon name="person-circle-outline"></ion-icon>
                Detalhes dos dias do usuário
              </span>
              <span class="header-subtitle">
                Gerencie os detalhes dos dias do usuário
              </span>
              <form v-on:submit.prevent="getList()">
                <div class="col-md-12 form-content">
                  <div class="col-md-4 form-text">
                    <label>Id do Usuário</label>
                    <div class="form-input">
                      <input v-model="userId" type="text" placeholder="Digite um id" autocomplete="off">
                      <ion-icon name="search-outline"></ion-icon>
                    </div>
                    <span v-if="validateId">* Preencha um ID do Usuário!</span>
                  </div>
                  <div class="col-md-4 form-text">
                    <label>Banco</label>
                    <div class="form-select">
                      <div class="form-select-input">
                        <select v-model="context">
                          <option value="">Selecione</option>
                          <option value="MMMM">MMMM</option>
                          <option value="AAAA">AAAA</option>
                          <option value="RRRR">RRRR</option>
                          <option value="QQQQ">QQQQ</option>
                          <option value="TTTT">TTTT</option>
                          <option value="EEEE">EEEE</option>
                        </select>
                        <ion-icon name="chevron-down-outline"></ion-icon>
                      </div>
                    </div>
                    <span v-if="validateContext">* Preencha um banco!</span>
                  </div>
                  <div class="col-md-4 form-datapicker">
                    <label>Data Inicial / Final</label>
                    <input type="text" class="datepicker-style" id="datepickerInitEnd">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                  <div class="col-md-2 form-btn">
                    <button type="submit">Pesquisar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <full-loading v-if="loadingList"/>
          <div v-else>
            <div v-if="dataDetails">
              <div class="col-md-12 content-sub-block">
                <!-- card one -->
                <div v-if="showDataUser" class="col-md-4 card-content">
                  <div class="card-header">
                  <span class="card-title">
                    Dados do usuário
                    <span v-on:click="showCard(1)">
                      <ion-icon name="chevron-up-outline"></ion-icon>
                    </span>
                  </span>
                  </div>
                  <div class="card-body">
                    <div class="card-list">
                      <div class="user-data">
                        <span>Nome: </span>
                        {{ dataDetails.usuario.nome }}
                      </div>
                      <div class="user-data">
                        <span>Cpf: </span>
                        {{ dataDetails.usuario.cpf | cpfOrCnpj }}
                      </div>
                      <div class="user-data">
                        <span>Criado em: </span>
                        {{ dataDetails.usuario.criadoEm }}
                      </div>
                      <div class="user-data">
                        <span>Turno atual: </span>
                        {{ dataDetails.usuario.turnoAtual }}
                      </div>
                      <div class="user-data">
                        <span>Ignorar horas faltantes na falta: </span>
                        {{ dataDetails.usuario.ignoraHorasFaltantesNaFalta }}
                      </div>
                      <span class="user-data">
                    <span>Precisa registrar ponto: </span>
                    {{ dataDetails.usuario.precisaRegistrarPonto }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-4 card-content card-content-low">
                  <div class="card-header">
                  <span class="card-title">
                    Dados do usuário
                    <span v-on:click="showCard(1)">
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </span>
                  </span>
                  </div>
                </div>
                <!-- card two -->
                <div v-if="showPossibleImpacts" class="col-md-4 card-content">
                  <div class="card-header">
                <span class="card-title">
                  Possíveis impactos
                  <span v-on:click="showCard(2)">
                    <ion-icon name="chevron-up-outline"></ion-icon>
                  </span>
                </span>
                  </div>
                  <div class="card-body">
                    <div class="card-list">
                      <div class="user-data">
                        <span>Empresa possui importação de escala: </span>
                        {{ dataDetails.possiveisImpactos.empresaPossuiImportacaoDeEscala }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-4 card-content card-content-low">
                  <div class="card-header">
                <span class="card-title">
                  Possíveis impactos
                  <span v-on:click="showCard(2)">
                    <ion-icon name="chevron-down-outline"></ion-icon>
                  </span>
                </span>
                  </div>
                </div>
                <!-- card three -->
                <div v-if="showChangeHistory" class="col-md-4 card-content">
                  <div class="card-header">
                  <span class="card-title">
                    Histórico de alterações
                    <span v-on:click="showCard(3)">
                      <ion-icon name="chevron-up-outline"></ion-icon>
                    </span>
                  </span>
                  </div>
                  <div class="card-body">
                    <div class="card-list">
                      <table>
                        <thead>
                        <tr>
                          <th>Data</th>
                          <th>Tipo</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataDetails.historicosDeAlteracao" :key='index'>
                          <td class="data">{{ item.data }}</td>
                          <td class="type">{{ item.tipo }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-4 card-content card-content-low">
                  <div class="card-header">
                  <span class="card-title">
                    Histórico de alterações
                    <span v-on:click="showCard(3)">
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </span>
                  </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 content-details">
                <div class="col-md-12 card-content" v-for="(value, index) in dataDetails.detalhesDosDias" :key="index">
                  <div class="card-header">
                    <span class="card-title">
                      Dia ( {{ value.data }} )
                      <span class="icon-arrow" v-on:click="showListCard(index)">
                        <ion-icon v-if="showLine[index].key" name="chevron-up-outline"></ion-icon>
                        <ion-icon v-else name="chevron-down-outline"></ion-icon>
                      </span>
                    </span>
                  </div>
                  <div v-if="showLine[index].key" class="col-md-12 card-day">
                    <div class="day-content">
                      <div class="day-header">
                        <span>Detalhes do dia</span>
                        <span class="day-arrow" v-on:click="showListCard2(index, 0)">
                        <ion-icon v-if="showLine[index].subKey[0].key" name="chevron-up-outline"></ion-icon>
                        <ion-icon v-else name="chevron-down-outline"></ion-icon>
                      </span>
                      </div>
                      <div v-if="showLine[index].subKey[0].key" class="day-body">
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Adicional noturno: </span>
                          {{ value.detalhesDoDia.adicionalNoturno }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Status de ajuste: </span>
                          {{ value.detalhesDoDia.ajusteStatus }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Criado em: </span>
                          {{ value.detalhesDoDia.criadoEm }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Esta em afastamento: </span>
                          {{ value.detalhesDoDia.estaEmAfastamento }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Esta em feriado: </span>
                          {{ value.detalhesDoDia.estaEmFeriado }}
                        </span>
                        </div>
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Horas a excedentes: </span>
                          {{ value.detalhesDoDia.horasExcedentes }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Horas faltantes: </span>
                          {{ value.detalhesDoDia.horasFaltantes }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Horas trabalhadas: </span>
                          {{ value.detalhesDoDia.horasTrabalhadas }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Motivo do espelho ponto: </span>
                          {{ value.detalhesDoDia.motivoEspelhoPonto }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Notas: </span>
                          {{ value.detalhesDoDia.notas }}
                        </span>
                        </div>
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Saldo: </span>
                          {{ value.detalhesDoDia.saldo }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Segunda fase: </span>
                          {{ value.detalhesDoDia.segundaFase }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Status: </span>
                          {{ value.detalhesDoDia.status }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Terceira fase: </span>
                          {{ value.detalhesDoDia.terceiraFase }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Tipo de afastamento: </span>
                          {{ value.detalhesDoDia.tipoAfastamento }}
                        </span>
                        </div>
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Possui pontos após meia noite: </span>
                          {{ value.detalhesDoDia.possuiPontosPosMidNight }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Primeira fase: </span>
                          {{ value.detalhesDoDia.primeiraFase }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Esta sincronizado: </span>
                          {{ value.detalhesDoDia.estaSincronizado }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Horas a trabalhar: </span>
                          {{ value.detalhesDoDia.horasATrabalhar }}
                        </span>
                          <span class="day-line">
                          <span class="day-title">Total de pontos: </span>
                          {{ value.detalhesDoDia.totalDePontos }}
                        </span>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Saldos</span>
                        <span v-if="value.saldos.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 1)">
                          <ion-icon v-if="showLine[index].subKey[1].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[1].key" class="day-body-three">
                        <div v-for="(settings, index) in value.saldos" class="day-group" :key="index">
                          <div
                            :class="[settings.estaDeletado == 'Não' ? 'bg-deleted-green' : 'bg-deleted-rose']"
                            class="day-group-content">
                            <div class="day-group-header">
                              <span class="created-at">{{ settings.criadoEm }}</span>
                            </div>
                            <div class="card-group">
                            <span class="card-title">Tipo do saldo:
                              <span class="content-title">{{ settings.tipoDoSaldo }}</span>
                            </span>
                              <span class="card-title">Tipo de tolerância:
                              <span class="content-title">{{ settings.tipoDeTolerancia }}</span>
                            </span>
                              <span class="card-title">Tolerancia aplicada:
                              <span class="content-title">{{ settings.toleranciaAplicada }}</span>
                            </span>
                              <span class="card-title">Fechamento:
                              <span class="content-title">{{ settings.doFechamento }}</span>
                            </span>
                              <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Turno do dia</span>
                        <span class="day-arrow" v-on:click="showListCard2(index, 2)">
                          <ion-icon v-if="showLine[index].subKey[2].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[2].key" class="day-body">
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Dia da semana: </span>
                          <span>{{ value.turnoDoDia.diaDaSemana }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Duração da primeira fase: </span>
                          <span>{{ value.turnoDoDia.duracaoPrimeiraFase }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Fase extraordinaria: </span>
                          <span>{{ value.turnoDoDia.faseExtraordinaria }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Fim adicional noturno: </span>
                          <span>{{ value.turnoDoDia.fimAdicionalNoturno }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Horas a trabalhar do dia: </span>
                          <span>{{ value.turnoDoDia.horasATrabalharDoDia }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Tolerância: </span>
                          <span>{{ value.turnoDoDia.tolerancia }}</span>
                        </span>
                        </div>
                        <div class="day-column day-column-mid">
                        <span class="day-line">
                          <span class="day-title">Ignorar feriado pós meia noite: </span>
                          <span>{{ value.turnoDoDia.ignoraFeriadoPosmidnight }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Ignorar feriado: </span>
                          <span>{{ value.turnoDoDia.ignoreFeriado }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Inicio adicional noturno: </span>
                          <span>{{ value.turnoDoDia.inicioAdicionalNoturno }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Nome do turno: </span>
                          <span>{{ value.turnoDoDia.nomeTurno }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Percentual segunda fase: </span>
                          <span>{{ value.turnoDoDia.percentualSegundaFase }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Usando regras do ponto: </span>
                          <span>{{ value.turnoDoDia.usandoRegrasDoPonto }}</span>
                        </span>
                        </div>
                        <div class="day-column">
                        <span class="day-line">
                          <span class="day-title">Percentual terceira fase: </span>
                          <span>{{ value.turnoDoDia.percentualTerceiraFase }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Percentual primeira fase: </span>
                          <span>{{ value.turnoDoDia.percetualPrimeiraFase }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Fuso horário: </span>
                          <span>{{ value.turnoDoDia.timezone }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Tipo da jornada: </span>
                          <span>{{ value.turnoDoDia.tipoDaJornada }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Tipo do turno: </span>
                          <span>{{ value.turnoDoDia.tipoDoTurno }}</span>
                        </span>
                          <span class="day-line">
                          <span class="day-title">Id do turno de trabalho : </span>
                          <span>{{ value.turnoDoDia.workshiftDayId }}</span>
                        </span>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Pontos</span>
                        <span v-if="value.pontos.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 3)">
                          <ion-icon v-if="showLine[index].subKey[3].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[3].key" class="day-body-reverse">
                        <div class="day-body-first">
                          <div v-for="(settings, index) in value.pontos" :key="index"
                               class="day-body-group">
                            <div v-if="settings.estaDeletado == 'Não'" class="day-group">
                              <div class="day-group-content bg-deleted-green">
                                <div class="day-group-header">
                                  <span class="created-at">{{ settings.criadoEm }}</span>
                                </div>
                                <div class="card-group">
                            <span class="card-title">Tipo:
                              <span class="content-title">{{ settings.tipo }}</span>
                            </span>
                                  <span class="card-title">Origem:
                              <span class="content-title">{{ settings.origem }}</span>
                            </span>
                                  <span class="card-title">Data do servidor:
                              <span class="content-title">{{ settings.dataServidor }}</span>
                            </span>
                                  <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="day-body-second">
                          <div v-for="(settings, index) in value.pontos" :key="index" class="day-body-deleted">
                            <div v-if="settings.estaDeletado == 'Sim'" class="day-group">
                              <div class="day-group-content bg-deleted-rose">
                                <div class="day-group-header">
                                  <span class="created-at">{{ settings.criadoEm }}</span>
                                </div>
                                <div class="card-group">
                            <span class="card-title">Tipo:
                              <span class="content-title">{{ settings.tipo }}</span>
                            </span>
                                  <span class="card-title">Origem:
                              <span class="content-title">{{ settings.origem }}</span>
                            </span>
                                  <span class="card-title">Data do servidor:
                              <span class="content-title">{{ settings.dataServidor }}</span>
                            </span>
                                  <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Ajustes</span>
                        <span v-if="value.ajustes.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 4)">
                          <ion-icon v-if="showLine[index].subKey[4].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[4].key" class="day-body-four">
                        <div v-for="(settings, index) in value.ajustes" class="day-group" :key="index">
                          <div
                            :class="[settings.estaDeletado == 'Não' ? 'bg-deleted-green' : 'bg-deleted-rose']"
                            class="day-group-content">
                            <div class="day-group-header">
                              <span class="created-at">{{ settings.criadoEM }}</span>
                              <span class="adjust-status">
                              <span class="status-title">Status: </span>
                              <span class="status-content">{{ settings.status }}</span>
                            </span>
                            </div>
                            <div class="card-group">
                              <div class="card-column">
                                <span class="card-title">Tipo:
                                  <span class="content-title">{{ settings.tipo }}</span>
                                </span>
                                <span class="card-title">Deletado:
                                  <span class="content-title">{{ settings.estaDeletado }}</span>
                                </span>
                                <span class="card-title">Horas solicitadas:
                                  <span class="content-title">{{ settings.extensoes[0].horasSolicitadas }}</span>
                                </span>
                              </div>
                              <div class="card-column card-column-history">
                                <span class="card-title card-title-points">Histórico</span>
                                <div class="card-group-points">
                                  <div v-for="(points, index) in settings.historicos" class="history-group"
                                       :key="index">
                                    <div class="card-history">
                                      <span class="history-creator">
                                        {{ index + 1 }} - De:
                                        <span> {{ points.historicoPor }}</span>
                                      </span>
                                      <span class="history-msg">
                                        <span> {{ points.mensagem }}</span>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="card-column">
                                <span class="card-title card-title-points">Pontos antes</span>
                                <div class="card-group-points">
                                  <div v-for="(points, index) in settings.extensoes[0].pontosAntigos" :key="index">
                                    <span class="entrance-title">
                                      <span v-if="points.userPointType === 1">Entrada: </span>
                                      <span v-else-if="points.userPointType === 2">Saída: </span>
                                      <span v-else>Desconhecido</span>
                                    </span>
                                    <span>{{ points.date | formatDate }}</span>
                                    <span>
                                      {{ points.date | formatHors24 }}
                                      <span>
                                        <span v-if="points.isEdited === true" class="point-edited"> Editado</span>
                                        <span v-else></span>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="card-column">
                                <span class="card-title card-title-points">Pontos depois</span>
                                <div class="card-group-points">
                                  <div v-for="(points, index) in settings.extensoes[0].pontosFinais" :key="index">
                                    <span class="entrance-title">
                                        <span v-if="points.userPointType === 1">Entrada: </span>
                                        <span v-else-if="points.userPointType === 2">Saída: </span>
                                        <span v-else>Desconhecido</span>
                                      </span>
                                    <span>{{ points.date | formatDate }}</span>
                                    <span>
                                      {{ points.date | formatHors24Z }}
                                      <span>
                                        <span v-if="points.isEdited === true" class="point-edited"> Editado</span>
                                        <span v-else></span>
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Afastamentos</span>
                        <span v-if="value.afastamentos.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 5)">
                          <ion-icon v-if="showLine[index].subKey[5].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[5].key" class="day-body-three">
                        <div v-for="(settings, index) in value.afastamentos" class="day-group" :key="index">
                          <div
                            :class="[settings.estaDeletado == 'Não' ? 'bg-deleted-green' : 'bg-deleted-rose']"
                            class="day-group-content">
                            <div class="day-group-header">
                              <span class="created-at">{{ settings.criadoEm }}</span>
                            </div>
                            <div class="card-group">
                            <span class="card-title">Tipo:
                              <span class="content-title">{{ settings.tipo }}</span>
                            </span>
                              <span class="card-title">Status:
                              <span class="content-title">{{ settings.status }}</span>
                            </span>
                              <span class="card-title">Início:
                              <span class="content-title">{{ settings.inicio }}</span>
                            </span>
                              <span class="card-title">Fim:
                              <span class="content-title">{{ settings.fim }}</span>
                            </span>
                              <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Feriados</span>
                        <span v-if="value.feriados.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 6)">
                          <ion-icon v-if="showLine[index].subKey[6].key" name="chevron-up-outline"></ion-icon>
                          <ion-icon v-else name="chevron-down-outline"></ion-icon>
                        </span>
                      </div>
                      <div v-if="showLine[index].subKey[6].key" class="day-body-three">
                        <div v-for="(settings, index) in value.feriados" class="day-group" :key="index">
                          <div
                            :class="[settings.estaDeletado == 'Não' ? 'bg-deleted-green' : 'bg-deleted-rose']"
                            class="day-group-content">
                            <div class="day-group-header">
                              <span class="created-at">{{ settings.criadoEm }}</span>
                            </div>
                            <div class="card-group">
                            <span class="card-title">Data:
                              <span class="content-title">{{ settings.data }}</span>
                            </span>
                              <span class="card-title">Nome:
                              <span class="content-title">{{ settings.nome }}</span>
                            </span>
                              <span class="card-title">Dia todo:
                              <span class="content-title">{{ settings.diaTodo }}</span>
                            </span>
                              <span class="card-title">Inicio:
                              <span class="content-title">{{ settings.inicio }}</span>
                            </span>
                              <span class="card-title">Fim:
                              <span class="content-title">{{ settings.fim }}</span>
                            </span>
                              <span class="card-title">Todos os funcionários:
                              <span class="content-title">{{ settings.todosFuncionarios }}</span>
                            </span>
                              <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="day-content">
                      <div class="day-header">
                        <span>Escalas</span>
                        <span v-if="value.escalas.length === 0">Vazio</span>
                        <span v-else class="day-arrow" v-on:click="showListCard2(index, 7)">
                        <ion-icon v-if="showLine[index].subKey[7].key" name="chevron-up-outline"></ion-icon>
                        <ion-icon v-else name="chevron-down-outline"></ion-icon>
                      </span>
                      </div>
                      <div v-if="showLine[index].subKey[7].key" class="day-body-three">
                        <div v-for="(settings, index) in value.escalas" class="day-group" :key="index">
                          <div
                            :class="[settings.estaDeletado == 'Não' ? 'bg-deleted-green' : 'bg-deleted-rose']"
                            class="day-group-content">
                            <div class="day-group-header">
                              <span class="created-at">{{ settings.criadoEm }}</span>
                            </div>
                            <div class="card-group">
                            <span class="card-title">Status:
                              <span class="content-title">{{ settings.status }}</span>
                            </span>
                              <span class="card-title">Inicio:
                              <span class="content-title">{{ settings.inicio }}</span>
                            </span>
                              <span class="card-title">Fim:
                              <span class="content-title">{{ settings.fim }}</span>
                            </span>
                              <span class="card-title">Deletado:
                              <span class="content-title">{{ settings.estaDeletado }}</span>
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- footer-menu -->
    <footer-menu v-if="!loadingGeneral"/>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import footerMenu from "../../../components/default/footerMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import datepicker from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";

import {DETAILS_DAYS_USER} from "../../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../../requestConfig";
import swal from "sweetalert";
import moment from "moment";


export default {
  name: "detailDaysUser",
  components: {
    topMenu,
    footerMenu,
    fullLoading,
    datepicker,
  },
  data() {
    return {
      ptBR: ptBR,
      loadingGeneral: false,
      loadingList: false,
      dataDetails: '',
      showDataUser: true,
      showPossibleImpacts: true,
      showChangeHistory: true,
      showLine: [],
      showLines2: [],
      userId: '',
      initDate: '',
      finalDate: '',
      validateId: false,
      validateContext: false,
      context: '',
    }
  },
  methods: {
    getList() {
      this.loadingList = true;

      const url = DETAILS_DAYS_USER
      const valueDataInitEnd = $('#datepickerInitEnd').val();

      const [init, end] = valueDataInitEnd.split('-')

      this.initDate = moment(init, "DD/MM/YYYY").format("YYYYMMDD");
      this.finalDate = moment(end, "DD/MM/YYYY").format("YYYYMMDD");

      let objSend = {};

      if (this.userId === '') {
        this.validateId = true
      }

      if (this.context === '') {
        this.validateContext = true
      }

      if (this.userId) {
        objSend.userId = this.userId;
        this.validateId = false
      }

      if (this.context) {
        this.validateContext = false
      }

      if (this.initDate)
        objSend.init = this.initDate;

      if (this.finalDate)
        objSend.end = this.finalDate;

      const newUrl = url + '?' + new URLSearchParams(objSend).toString()

      if (this.validateId === false && this.validateContext === false) {
        REQUEST_SERVICE.requestContext("GET", newUrl, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT DETAILS_DAYS_USER:", response.data);

            this.dataDetails = response.data;

            this.dataDetails.detalhesDosDias.map((v, index) => {
              this.showLine.push({
                key: true, subKey: [
                  {key: true},
                  {key: true},
                  {key: true},
                  {key: true},
                  {key: true},
                  {key: true},
                  {key: true},
                  {key: true},
                ]
              });
            })

            this.loadingList = false;
          })
          .catch((reason) => {
            this.loadingList = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        this.loadingList = false;
      }
    },
    showCard(value) {
      switch (value) {
        case 1:
          this.showDataUser = !this.showDataUser
          break

        case 2:
          this.showPossibleImpacts = !this.showPossibleImpacts
          break

        case 3:
          this.showChangeHistory = !this.showChangeHistory
          break
      }
    },
    showListCard(value) {
      this.showLine[value].key = !this.showLine[value].key

      let number = 0;
      for (; number <= 7; number++) {
        if (!this.showLine[value].key) {
          this.showLine[value].subKey[number].key = false;
        }
      }
    },
    showListCard2(value, subkey) {
      this.showLine[value].subKey[subkey].key = !this.showLine[value].subKey[subkey].key
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  mounted() {
    const date = new Date();
    const startDate = moment(date).format('DD/MM/YYYY')

    $('#datepickerInitEnd').daterangepicker({
      "maxSpan": {
        "days": 7
      },
      "startDate": startDate,
      "locale": {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Aplicar",
        "cancelLabel": "Cancelar",
        "fromLabel": "De:",
        "toLabel": "Para:",
        "customRangeLabel": "Personalizados",
        "weekLabel": "Semana",
        "daysOfWeek": [
          "Dom",
          "Seg",
          "Ter",
          "Qua",
          "Qui",
          "Sex",
          "Sáb"
        ],
        "monthNames": [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        "firstDay": 1
      },
    });
  }
}
</script>

<style lang="scss">

.daterangepicker {
  margin-top: 15px;
  border-radius: 10px !important;
  font-family: Montserrat;
  font-weight: 500;

  .ranges {
    display: none;
  }

  .drp-buttons {
    .drp-selected {
      font-weight: 700;
    }

    .cancelBtn {
      border-radius: 4px !important;
      transition: .2s !important;
    }

    .applyBtn {
      background: #2F23D6;
      border: 1px solid #2F23D6;
      color: #FFFFFF;
      border-radius: 4px !important;
      transition: .2s !important;
      padding: 4px 28px;

      &:hover {
        background: #261CAB;
      }
    }
  }

  .calendar-table {
    .table-condensed {
      thead {

        tr {
          th {
            cursor: auto;
            font-weight: 600;
            min-width: 34px;
            width: 34px;
            max-width: 34px;
          }

          .next {
            cursor: pointer;
          }

          .prev {
            cursor: pointer;
          }

          .month {
            font-weight: 700;
          }
        }
      }

      tbody {
        tr {
          .start-date {
            border-top-left-radius: 8px !important;
            border-bottom-left-radius: 8px !important;
          }

          .end-date {
            border-top-right-radius: 8px !important;
            border-bottom-right-radius: 8px !important;
          }

          .active {
            background-color: #2F23D6 !important;

            &:hover {
              background-color: #271DB0 !important;
            }
          }

          .in-range {
            background-color: #2F23D642;
          }

          .available {
            &:hover {
              background-color: #2F23D61C;
            }
          }

          .off {
            background-color: #FFF !important;
          }
        }
      }
    }
  }
}

.loader-page-content {
  margin-top: 25rem !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  padding: 0 !important;

  .spinner {
    .rect1 {
      background: #2F23D6;
    }

    .rect2 {
      background: #2F23D6;
    }

    .rect3 {
      background: #2F23D6;
    }

    .rect4 {
      background: #2F23D6;
    }

    .rect5 {
      background: #2F23D6;
    }
  }
}

.page-content {
  min-height: 60rem;
}

.content-block {
  padding: 20px 30px;
  background: var(--classic-white);
  border-radius: 10px !important;

  .content-header {
    .header-title {
      display: flex;
      align-items: center;

      font-size: 18px;
      font-weight: 700;
      color: var(--classic-black);

      ion-icon {
        margin-right: 5px;
        font-size: 23px;
        color: var(--dark-gray);
      }
    }

    .header-subtitle {
      font-size: 14px;
      font-weight: 400;
      color: var(--dark-gray);
    }

    form {
      .form-content {
        display: flex;
        margin-top: 25px;
        margin-bottom: 25px;
        padding: 0;

        .form-text {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          span {
            position: absolute;
            top: 0;
            right: 0;
            color: var(--light-red);
          }

          .form-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #CACACA;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #CACACA;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }

          .form-select {
            display: flex;
            flex-direction: column;
            padding: 0;
            //margin-right: 15px;
            //margin-left: 15px;

            .form-select-input {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;
              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #CACACA;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #CACACA;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }
        }

        .form-datapicker {
          position: relative;
          padding: 0 15px 0 0;

          .datepicker-style {
            cursor: pointer;
            width: 100%;
            background: #EEF2F7;
            border-radius: 4px !important;
            padding: 6px 12px;
            border: 1px solid #EEF2F7;
            transition: .2s;

            font-size: 16px;
            font-weight: 400;
            color: var(--dark-gray);

            &::placeholder {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            &:hover {
              transition: .2s;
              border: 1px solid #CACACA;
            }

            &:focus-visible {
              outline: none;
              transition: .2s;
              border: 1px solid #CACACA;

              &::placeholder {
                transition: .1s;
                color: #EEF2F7;
              }
            }
          }

          i {
            position: absolute;
            right: 30px;
            bottom: 12px;
            color: #111;
          }
        }

        .form-btn {
          button {
            width: 100%;
            height: 59%;
            margin-top: 25.5px;
            background: #2F23D6;
            color: #FFFFFF;
            border-radius: 4px !important;
            border: none;
            transition: .2s;

            &:hover {
              background: #261CAB;
            }
          }
        }
      }
    }
  }
}

.content-sub-block {
  display: flex;
  gap: 30px;
  margin-top: 30px;
  padding: 0;

  .card-content-low {
    height: 60px;
  }

  .card-content {
    padding: 20px 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .card-header {
      .card-title {
        display: flex;
        justify-content: space-between;

        font-size: 16px;
        font-weight: 700;
        color: var(--dark-black);

        span {
          cursor: pointer;
        }
      }
    }

    .card-body {
      margin-top: 12px;
      overflow-y: auto;
      min-height: 325px;
      max-height: 325px;

      .card-list {
        display: flex;
        flex-direction: column;

        .user-data {
          margin-top: 10px;
          color: var(--dark-gray);

          span {
            font-weight: 600;
          }

          &:first-child {
            margin-top: 0;
          }
        }

        table {
          width: 99%;
          max-width: 99%;
          margin-bottom: 20px;

          thead {
            position: relative;

            font-size: 14px;
            color: var(--high-gray);
            line-height: 220%;
            padding-bottom: 5px;
            border-bottom: 1px solid var(--classic-gray);

            tr {
              top: 0;
              position: sticky;
              background: var(--classic-white);

              th {
                font-weight: 500 !important;
              }
            }
          }

          tbody {
            tr {
              border-bottom: 1px solid var(--classic-gray);

              td {
                color: var(--dark-gray);
              }

              .data {
                padding: 5px 10px 5px 0;
              }

              .type {
                text-transform: lowercase;
                padding: 5px 0 5px 0;

                &::first-letter {
                  text-transform: uppercase;
                }
              }
            }
          }
        }
      }
    }

    .card-body::-webkit-scrollbar {
      width: 4px;
      position: absolute;
    }

    .card-body::-webkit-scrollbar-track {
      background-color: #E6E9EC;
      height: 4px;
      border-radius: 6px;
    }

    .card-body::-webkit-scrollbar-thumb {
      background: #3A424E;
      border-radius: 6px;
    }

    .card-body::-webkit-scrollbar-thumb:hover {
      background: lighten(#3A424E, 5%);
      transition: 0.5s;
    }
  }
}

.content-details {
  display: flex;
  flex-direction: column-reverse;

  margin-top: 30px;
  padding: 0;

  .card-content {
    margin-bottom: 30px;
    padding: 20px 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .card-header {
      .card-title {
        display: flex;
        justify-content: space-between;

        font-size: 16px;
        font-weight: 700;
        color: var(--dark-black);

        .icon-arrow {
          font-size: 23px;
          height: 23px;
          cursor: pointer;
        }
      }
    }

    .card-day {
      margin-top: 30px;
      padding: 0;

      .day-content {
        margin-top: 15px;
        padding: 10px 15px;
        background: var(--classic-white);
        border-radius: 10px !important;
        border: 1px solid var(--border-gray);

        &:first-child {
          margin-top: 0;
        }

        .day-header {
          display: flex;
          justify-content: space-between;

          font-size: 16px;
          font-weight: 700;
          color: var(--dark-gray);

          .day-arrow {
            font-size: 22px;
            height: 22px;
            cursor: pointer;
          }
        }

        .day-body {
          display: flex;
          justify-content: space-between;

          margin-top: 20px;

          .day-column {
            display: flex;
            flex-direction: column;

            .day-line {
              color: var(--dark-gray);
              margin-top: 10px;

              &:first-child {
                margin-top: 0;
              }

              &:last-child {
                margin-bottom: 5px;
              }

              .day-title {
                font-weight: 600;
              }
            }
          }

          .day-column-mid {
            width: 33%;
          }
        }

        .day-body-two {
          display: flex;
          justify-content: space-around;
          flex-direction: row-reverse;
          flex-wrap: wrap;

          .day-group {
            margin-top: 20px;

            &:last-child {
              margin-bottom: 10px;
            }

            .bg-deleted-rose {
              background: #FFBEBE;
            }

            .bg-deleted-green {
              background: #BEFFD2;
            }

            .day-group-content {
              border: 1px solid var(--border-gray);
              border-radius: 10px !important;
              padding: 10px 10px;

              .day-group-header {
                display: flex;
                justify-content: space-between;

                .created-at {
                  font-size: 18px;
                  font-weight: 700;
                  color: var(--dark-gray);
                }

                .adjust-status {
                  font-size: 14px;

                  .status-title {
                    font-weight: 600;
                  }

                  .status-content {
                    font-weight: 400;
                  }
                }
              }

              .card-group {
                display: flex;
                flex-direction: column;
                margin-top: 10px;

                .card-title {
                  color: var(--dark-gray);
                  font-weight: 600;
                  margin-bottom: 5px;

                  .content-title {
                    font-weight: 400;
                  }
                }

                .adjust-group {
                  margin-top: 10px;
                  border: 1px solid var(--border-gray);
                  border-radius: 10px !important;
                  padding: 5px 15px;
                  text-align: center;

                  .old-stitches {
                    color: var(--dark-gray);

                    .old-title {
                      font-weight: 600;
                    }

                    .old-group {
                      display: flex;
                      margin-top: 3px;

                      .old-status {
                        font-weight: 500;
                      }

                      .old-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .endpoints {
                    border-top: 1px solid #B8B8B8;
                    padding-top: 5px;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .new-title {
                      font-weight: 600;
                    }

                    .new-group {
                      display: flex;
                      margin-top: 3px;

                      .new-status {
                        font-weight: 500;
                      }

                      .new-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .requested-hours {
                    border-top: 1px solid #B8B8B8;
                    padding: 10px 0;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .requested-total {
                      font-size: 18px;

                      .requested-title {
                        font-weight: 600;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .day-body-reverse {
          .day-body-first {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-around;

            .day-body-group {
              .day-group {
                margin-top: 20px;

                &:last-child {
                  margin-bottom: 10px;
                }

                .bg-deleted-rose {
                  background: #FFBEBE;
                }

                .bg-deleted-green {
                  background: #BEFFD2;
                }

                .day-group-content {
                  border: 1px solid var(--border-gray);
                  border-radius: 10px !important;
                  padding: 10px 10px;

                  .day-group-header {
                    display: flex;
                    justify-content: space-between;

                    .created-at {
                      font-size: 18px;
                      font-weight: 700;
                      color: var(--dark-gray);
                    }

                    .adjust-status {
                      font-size: 14px;

                      .status-title {
                        font-weight: 600;
                      }

                      .status-content {
                        font-weight: 400;
                      }
                    }
                  }

                  .card-group {
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;

                    .card-title {
                      color: var(--dark-gray);
                      font-weight: 600;
                      margin-bottom: 5px;

                      .content-title {
                        font-weight: 400;
                      }
                    }

                    .adjust-group {
                      margin-top: 10px;
                      border: 1px solid var(--border-gray);
                      border-radius: 10px !important;
                      padding: 5px 15px;
                      text-align: center;

                      .old-stitches {
                        color: var(--dark-gray);

                        .old-title {
                          font-weight: 600;
                        }

                        .old-group {
                          display: flex;
                          margin-top: 3px;

                          .old-status {
                            font-weight: 500;
                          }

                          .old-entry {
                            display: flex;
                            gap: 4%;
                          }
                        }
                      }

                      .endpoints {
                        border-top: 1px solid #B8B8B8;
                        padding-top: 5px;
                        margin-top: 5px;
                        color: var(--dark-gray);

                        .new-title {
                          font-weight: 600;
                        }

                        .new-group {
                          display: flex;
                          margin-top: 3px;

                          .new-status {
                            font-weight: 500;
                          }

                          .new-entry {
                            display: flex;
                            gap: 4%;
                          }
                        }
                      }

                      .requested-hours {
                        border-top: 1px solid #B8B8B8;
                        padding: 10px 0;
                        margin-top: 5px;
                        color: var(--dark-gray);

                        .requested-total {
                          font-size: 18px;

                          .requested-title {
                            font-weight: 600;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          .day-body-second {
            margin-top: 15px !important;
            padding-top: 4px !important;
            border-top: 1px solid var(--classic-gray);
            display: flex;
            justify-content: space-around;

            .day-body-deleted {
              .day-group {
                margin-top: 20px;

                &:last-child {
                  margin-bottom: 10px;
                }

                .bg-deleted-rose {
                  background: #FFBEBE;
                }

                .bg-deleted-green {
                  background: #BEFFD2;
                }

                .day-group-content {
                  border: 1px solid var(--border-gray);
                  border-radius: 10px !important;
                  padding: 10px 10px;

                  .day-group-header {
                    display: flex;
                    justify-content: space-between;

                    .created-at {
                      font-size: 18px;
                      font-weight: 700;
                      color: var(--dark-gray);
                    }

                    .adjust-status {
                      font-size: 14px;

                      .status-title {
                        font-weight: 600;
                      }

                      .status-content {
                        font-weight: 400;
                      }
                    }
                  }

                  .card-group {
                    display: flex;
                    flex-direction: column;
                    margin-top: 10px;

                    .card-title {
                      color: var(--dark-gray);
                      font-weight: 600;
                      margin-bottom: 5px;

                      .content-title {
                        font-weight: 400;
                      }
                    }

                    .adjust-group {
                      margin-top: 10px;
                      border: 1px solid var(--border-gray);
                      border-radius: 10px !important;
                      padding: 5px 15px;
                      text-align: center;

                      .old-stitches {
                        color: var(--dark-gray);

                        .old-title {
                          font-weight: 600;
                        }

                        .old-group {
                          display: flex;
                          margin-top: 3px;

                          .old-status {
                            font-weight: 500;
                          }

                          .old-entry {
                            display: flex;
                            gap: 4%;
                          }
                        }
                      }

                      .endpoints {
                        border-top: 1px solid #B8B8B8;
                        padding-top: 5px;
                        margin-top: 5px;
                        color: var(--dark-gray);

                        .new-title {
                          font-weight: 600;
                        }

                        .new-group {
                          display: flex;
                          margin-top: 3px;

                          .new-status {
                            font-weight: 500;
                          }

                          .new-entry {
                            display: flex;
                            gap: 4%;
                          }
                        }
                      }

                      .requested-hours {
                        border-top: 1px solid #B8B8B8;
                        padding: 10px 0;
                        margin-top: 5px;
                        color: var(--dark-gray);

                        .requested-total {
                          font-size: 18px;

                          .requested-title {
                            font-weight: 600;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .day-body-two-empty {
          .empty-state-group {
            padding: 10px 0 40px 0;
            text-align: center;

            .empty-state-text {
              display: flex;
              justify-content: center;
              flex-direction: column;
              width: 45%;
              margin: auto;

              .empty-state-title {
                font-weight: 700;
                font-size: 16px;
                color: var(--dark-gray);
              }

              .empty-state-subtitle {
                font-weight: 400;
                font-size: 16px;
                color: var(--dark-gray);
              }
            }
          }
        }

        .day-body-three {
          .day-group {
            margin-top: 20px;

            &:last-child {
              margin-bottom: 10px;
            }

            .bg-deleted-rose {
              background: #FFBEBE;
            }

            .bg-deleted-green {
              background: #BEFFD2;
            }

            .day-group-content {
              border: 1px solid var(--border-gray);
              border-radius: 10px !important;
              padding: 10px 10px;
              margin-bottom: 15px;

              .day-group-header {
                display: flex;
                justify-content: space-between;

                .created-at {
                  font-size: 18px;
                  font-weight: 700;
                  color: var(--dark-gray);
                }

                .adjust-status {
                  font-size: 14px;

                  .status-title {
                    font-weight: 600;
                  }

                  .status-content {
                    font-weight: 400;
                  }
                }
              }

              .card-group {
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                justify-content: space-between;

                .card-title {
                  color: var(--dark-gray);
                  font-weight: 600;
                  margin-bottom: 5px;

                  .content-title {
                    font-weight: 400;
                  }
                }

                .adjust-group {
                  margin-top: 10px;
                  border: 1px solid var(--border-gray);
                  border-radius: 10px !important;
                  padding: 5px 15px;
                  text-align: center;

                  .old-stitches {
                    color: var(--dark-gray);

                    .old-title {
                      font-weight: 600;
                    }

                    .old-group {
                      display: flex;
                      margin-top: 3px;

                      .old-status {
                        font-weight: 500;
                      }

                      .old-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .endpoints {
                    border-top: 1px solid #B8B8B8;
                    padding-top: 5px;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .new-title {
                      font-weight: 600;
                    }

                    .new-group {
                      display: flex;
                      margin-top: 3px;

                      .new-status {
                        font-weight: 500;
                      }

                      .new-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .requested-hours {
                    border-top: 1px solid #B8B8B8;
                    padding: 10px 0;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .requested-total {
                      font-size: 18px;

                      .requested-title {
                        font-weight: 600;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .day-body-four {
          .day-group {
            margin-top: 20px;

            &:last-child {
              margin-bottom: 10px;
            }

            .bg-deleted-rose {
              background: #FFBEBE;
            }

            .bg-deleted-green {
              background: #BEFFD2;
            }

            .day-group-content {
              border: 1px solid var(--border-gray);
              border-radius: 10px !important;
              padding: 10px 10px;
              margin-bottom: 15px;

              .day-group-header {
                display: flex;
                justify-content: space-between;

                .created-at {
                  font-size: 18px;
                  font-weight: 700;
                  color: var(--dark-gray);
                }

                .adjust-status {
                  font-size: 16px;

                  .status-title {
                    font-weight: 600;
                  }

                  .status-content {
                    font-weight: 400;
                  }
                }
              }

              .card-group {
                display: flex;
                margin-top: 10px;
                flex-direction: row;
                justify-content: space-between;

                .card-column {
                  display: flex;
                  flex-direction: column;

                  .card-title-points {
                    text-align: center;
                  }

                  .card-group-points {
                    .entrance-title {
                      font-weight: 600;
                    }

                    .point-edited {
                      color: var(--light-red);
                      font-weight: 500;
                    }

                    .history-group {
                      .card-history {
                        display: flex;
                        flex-direction: column;
                        flex-wrap: wrap;
                        word-break: break-all !important;

                        border: 1px solid var(--dark-gray);
                        padding: 4px 8px;
                        border-radius: 10px !important;
                        margin-bottom: 10px;

                        .history-title {
                          color: var(--dark-gray);
                          font-weight: 600;
                          margin-bottom: 5px;
                        }

                        .history-creator {
                          color: var(--dark-gray);
                          font-weight: 600;
                          margin-bottom: 5px;

                          span {
                            font-weight: 400;
                          }
                        }

                        .history-msg {
                          color: var(--dark-gray);
                          font-weight: 600;
                          margin-bottom: 5px;

                          span {
                            font-weight: 400;
                          }
                        }
                      }
                    }
                  }
                }

                .card-column-history {
                  max-width: 20% !important;
                }

                .card-title {
                  color: var(--dark-gray);
                  font-weight: 600;
                  margin-bottom: 5px;

                  .content-title {
                    font-weight: 400;
                  }
                }

                .adjust-group {
                  margin-top: 10px;
                  border: 1px solid var(--border-gray);
                  border-radius: 10px !important;
                  padding: 5px 15px;
                  text-align: center;

                  .old-stitches {
                    color: var(--dark-gray);

                    .old-title {
                      font-weight: 600;
                    }

                    .old-group {
                      display: flex;
                      margin-top: 3px;

                      .old-status {
                        font-weight: 500;
                      }

                      .old-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .endpoints {
                    border-top: 1px solid #B8B8B8;
                    padding-top: 5px;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .new-title {
                      font-weight: 600;
                    }

                    .new-group {
                      display: flex;
                      margin-top: 3px;

                      .new-status {
                        font-weight: 500;
                      }

                      .new-entry {
                        display: flex;
                        gap: 4%;
                      }
                    }
                  }

                  .requested-hours {
                    border-top: 1px solid #B8B8B8;
                    padding: 10px 0;
                    margin-top: 5px;
                    color: var(--dark-gray);

                    .requested-total {
                      font-size: 18px;

                      .requested-title {
                        font-weight: 600;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.d-none {
  display: none !important;
}

.d-block {
  display: block !important;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/user/detailDaysUser/detailDaysUser.vue